import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=bb7076cc&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=bb7076cc&prod&lang=css"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=bb7076cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7076cc",
  null
  
)

export default component.exports